<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initFirstVisit } from '@/utils/localStorage'
import Clarity from '@microsoft/clarity';

export default {
  name: 'App',
  mounted() {
    // 在应用挂载时执行首次访问逻辑
    initFirstVisit()
    Clarity.init('tugjwa0po1');
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
